import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { UserRole } from "@src/views/project-tasks/domain/task.model";

const initialState = {
  role: UserRole.CREATOR,
  loading: false,
  error: "",
};

export const changeUserRole = createAsyncThunk(
  "userRole/changeUserRole",
  async (newRole: UserRole) => {
    return newRole || UserRole.ADMIN;
  }
);

export const findUser = createAsyncThunk(
  "userRole/findUser",
  async (id: string) => {
    return;
  }
);

const userRoleSlice = createSlice({
  name: "userRole",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(changeUserRole.pending, (state) => {
        state.loading = true;
        state.error = "";
      })
      .addCase(changeUserRole.fulfilled, (state, action) => {
        state.loading = false;
        state.role = action.payload;
      })
      .addCase(changeUserRole.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "";
      });
  },
});

export default userRoleSlice.reducer;
